export default [
  {
    path: 'M64 64m102.4 0l691.2 0q102.4 0 102.4 102.4l0 691.2q0 102.4-102.4 102.4l-691.2 0q-102.4 0-102.4-102.4l0-691.2q0-102.4 102.4-102.4Z',
    fill: '#002026',
  },
  {
    path: 'M857.6 983.04H166.4a125.5808 125.5808 0 0 1-125.44-125.44V166.4a125.5808 125.5808 0 0 1 125.44-125.44h691.2a125.5808 125.5808 0 0 1 125.44 125.44v691.2a125.5808 125.5808 0 0 1-125.44 125.44zM166.4 87.04a79.4496 79.4496 0 0 0-79.36 79.36v691.2a79.4496 79.4496 0 0 0 79.36 79.36h691.2a79.4496 79.4496 0 0 0 79.36-79.36V166.4a79.4496 79.4496 0 0 0-79.36-79.36z',
    fill: '#00DBFF',
  },
  {
    path: 'M315.392 329.216h161.28c104.448 0 124.416 67.584 124.416 113.152 0 45.056-19.968 112.64-124.416 112.128h-97.28v140.288h-64z m64 173.056h93.696c28.672 0 64-14.336 64-60.416 0-48.128-29.184-60.416-62.976-60.416h-94.72zM650.24 329.216h58.368v365.568H650.24z',
    fill: '#00DBFF',
  },
]
